// extracted by mini-css-extract-plugin
export default {"pageWrapper":"footer_pageWrapper__DSMd1","content":"footer_content__RlY3m","footer":"footer_footer__f9nLB"};